import { FC, useState } from 'react';

import { t } from 'i18next';

import ConfirmationModal from '@/components/popups/ConfirmationModal';

import { IframeView } from '../common';

import { SearchDocument } from '@/_generated/api-clients/xp';

interface GameProps {
  document: SearchDocument;
}

const GameBetterOnLargeScreenConfirm = ({
  className,
}: {
  className?: string;
}) => {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <ConfirmationModal
      overlayProps={{ className }}
      className={className}
      bodyText={t('games.betterOnALargeScreenBody')}
      headerText={t('games.betterOnALargeScreenTitle')}
      isOpen={isOpen}
      primaryButtonHandler={() => {
        setIsOpen(false);
      }}
      onClose={() => {
        setIsOpen(false);
      }}
      primaryButtonText={t('games.betterOnALargeScreenConfirm')}
    />
  );
};

/** Game document. */
const Game: FC<GameProps> = ({ document }) => (
  <>
    <GameBetterOnLargeScreenConfirm className="md:hidden" />
    <IframeView url={document.contentUrl} />
  </>
);

export default Game;
